import { smallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(smallHeadingAndTextStyles, {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;

            @media print {
                display: block;
            }
        `,
    },
    heading: {
        variant: "legend",
        size: TYPOGRAPHY.size.smaller,
        weight: TYPOGRAPHY.weight.bold,
    },
});
